// Scroll reveal
const observer = new IntersectionObserver(entries => {
  entries.forEach((e, i) => {
    if (e.isIntersecting) {
      setTimeout(() => e.target.classList.add('visible'), i * 80);
      observer.unobserve(e.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.og-card, .og-feature, .og-review').forEach(el => observer.observe(el));

// Product page thumbnail switcher
document.querySelectorAll('.og-product__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const src = thumb.querySelector('img').src;
    const main = document.querySelector('.og-product__main-img img');
    if (main) main.src = src;
    document.querySelectorAll('.og-product__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Quantity buttons
document.querySelectorAll('.og-qty-minus').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
  });
});
document.querySelectorAll('.og-qty-plus').forEach(btn => {
  btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    if (input) input.value = parseInt(input.value) + 1;
  });
});

// Hero click to shop
const hero = document.getElementById('og-hero');
if (hero) {
  hero.addEventListener('click', e => {
    if (!e.target.closest('a') && !e.target.closest('button')) {
      window.location.href = '/collections/all';
    }
  });
}

// Floating gadgets
const gadgetContainer = document.getElementById('og-gadgets');
if (gadgetContainer) {
  const emojis = ['🧹','💨','🫧','⚡','🔋','🧽','💡','🔌','🪣','✨'];
  const count = window.innerWidth < 600 ? 6 : 10;
  for (var i = 0; i < count; i++) {
    var el = document.createElement('div');
    el.className = 'og-gadget';
    el.textContent = emojis[i % emojis.length];
    el.style.left = (Math.random() * 88 + 6) + '%';
    el.style.top  = (Math.random() * 75 + 10) + '%';
    el.style.fontSize = (1.5 + Math.random() * 2) + 'rem';
    el.style.animationDuration = (5 + Math.random() * 5) + 's';
    el.style.animationDelay   = (Math.random() * 4) + 's';
    gadgetContainer.appendChild(el);
  }
}
